export function importDateLocale(locale: string): Promise<any> {
  switch (locale) {
    case 'en':
      return import('date-fns/locale/en-GB')
    case 'es':
      return import('date-fns/locale/es')
    case 'pt':
      return import('date-fns/locale/pt')
    case 'fr':
      return import('date-fns/locale/fr')
    case 'it':
      return import('date-fns/locale/it')
    case 'de':
      return import('date-fns/locale/de')
    default:
      return Promise.resolve()
  }
}
